export const AUDIO_SECTION_TITLE_RENDERED = 'AUDIO_SECTION_TITLE_RENDERED';
export const AUDIO_DESCRIPTION_RENDERED = 'AUDIO_DESCRIPTION_RENDERED';
export const AUDIO_IFRAME_RENDERED = 'AUDIO_IFRAME_RENDERED';
export const AUDIO_OVERLAY_RENDERED = 'AUDIO_OVERLAY_RENDERED';
export const AUDIO_HEADLINE_RENDERED = 'AUDIO_HEADLINE_RENDERED';
